export const getRank = (rankedArray, index, scoreKey = "total") => {
  if (index === 0) return 1;

  // 이전 항목과 점수가 같으면 같은 랭킹
  if (rankedArray[index][scoreKey] === rankedArray[index - 1][scoreKey]) {
    return getRank(rankedArray, index - 1, scoreKey);
  }

  // 점수가 다르면 현재 인덱스 + 1
  return index + 1;
};
